module.exports = __webpack_public_path__ + "img/culture_active6.a941ca6f.png";